export const Button = ({
  id= undefined,
  label,
  theme = undefined,
  size = undefined,
  className = undefined,
  onClick = undefined,
  disabled = false,
}: {
  id?: string;
  label: string;
  theme?: string;
  size?: string;
  className?: string;
  onClick?: () => (void | Promise<void>);
  disabled?: boolean;
}) => {
  switch (theme) {
    case "black":
      className = `text-white bg-gray-900 hover:bg-black disabled:cursor-not-allowed disabled:opacity-75 ${className}`;
      break;
    case "outline-black":
      className = `bg-transparent ring-2 ring-gray-900 hover:ring-black text-gray-500 hover:text-gray-600 shadow-sm ${className}`;
      break;
    case "text-black":
      className = `text-gray-900 hover:text-black ${className}`;
      break;
    case "primary":
      className = `text-white bg-brand-blue-400 hover:bg-brand-blue-500 disabled:cursor-not-allowed disabled:opacity-75 ${className}`;
      break;
    case "outline-primary":
      className = `bg-transparent ring-2 ring-brand-blue-400 hover:ring-brand-blue-500 text-gray-500 hover:text-gray-600 shadow-sm ${className}`;
      break;
    case "text-primary":
      className = `text-brand-blue-400 hover:text-brand-blue-600 ${className}`;
      break;
    case "secondary":
      className = `text-white disabled:cursor-not-allowed disabled:opacity-75 bg-gray-500 hover:bg-gray-600 ${className}`;
      break; 
    case "outline-secondary":
      className = `bg-transparent ring-2 ring-gray-500 hover:ring-gray-600 text-gray-500 hover:text-gray-600 shadow-sm ${className}`;
      break;
    case "text-secondary":
      className = `text-gray-500 hover:text-gray-600 ${className}`;
      break;
    case "success":
      className = `text-white disabled:cursor-not-allowed disabled:opacity-75 bg-green-500 hover:bg-green-600 ${className}`;
      break;
    case "outline-success":
      className = `bg-transparent ring-2 ring-green-500 hover:ring-green-600 text-gray-500 hover:text-gray-600 shadow-sm ${className}`;
      break;
    case "text-success":
      className = `text-green-500 hover:text-green-600 ${className}`;
      break;
    case "warning":
      className = `text-white bg-orange-400 hover:bg-orange-500 disabled:cursor-not-allowed disabled:opacity-75 ${className}`;
      break;
    case "outline-warning":
      className = `bg-transparent ring-2 ring-orange-400 hover:ring-orange-500 text-gray-500 hover:text-gray-600 shadow-sm ${className}`;
      break;
    case "text-warning":
      className = `text-orange-500 hover:text-orange-600 ${className}`;
      break;
    case "danger":
      className = `text-white bg-red-500 hover:bg-red-600 disabled:cursor-not-allowed disabled:opacity-75 ${className}`;
      break;
    case "outline-danger":
      className = `bg-transparent ring-2 ring-red-500 hover:ring-red-600 text-gray-500 hover:text-gray-600 shadow-sm ${className}`;
      break;
    case "text-danger":
      className = `text-red-500 hover:text-red-600 ${className}`;
      break;
  }

  switch (size) {
    case "medium":
      className = `px-12 py-2.5 font-medium text-center ${className}`;
      break;
    case "outline-medium":
      className = `px-12 py-2 font-medium text-center ${className}`;
      break;
    case "small":
      className = `px-4 py-1.5 font-medium text-center ${className}`;
      break;
    case "outline-small":
      className = `px-4 py-1 font-medium text-center ${className}`;
      break;
  }

  return (
    <button id={id} className={className} onClick={onClick} disabled={disabled}>
      {label}
    </button>
  );
};
